import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import MenuIcon from "@material-ui/icons/Menu";
import Icon from "@material-ui/core/Icon";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Router, Link, Redirect, navigate } from "@reach/router";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import red from "@material-ui/core/colors/red";
import LoginDialogButton from "./LoginDialogButton";
import { withSnackbar } from "notistack";
import MenuForLogin from "./MenuForLogin";
import SERVER_ADDRESS from "../../../config";
import store from "../../../reduxstore";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 2
  },

  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  button: {
    margin: theme.spacing(1)
  },
  appbar: {
    marginBottom: 1
  }
}));

function useMenu(initAnchorEl) {
  const [anchorEl, setAnchorEl] = React.useState(initAnchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = e => {
    setAnchorEl(e.currentTarget);
  };
  return { anchorEl, handleClick, handleClose };
}

//导航栏中使用的用户登录信息按钮
function AccountMenu(props) {
  const classes = useStyles();
  let { anchorEl, handleClick, handleClose } = useMenu(null);

  const { account } = store.getState();
  let auth = Boolean(account.id);
  return (
    <div>
      {auth ? (
        <MenuForLogin
          account={account}
          anchorEl={anchorEl}
          handleClick={handleClick}
          handleClose={handleClose}
        />
      ) : (
        <div>
          <LoginDialogButton color="inherit">
            <Typography
              variant="body1"
              color="secondary"
              className={classes.grow}
            >
              登录
            </Typography>
          </LoginDialogButton>
        </div>
      )}
    </div>
  );
}

export default AccountMenu;
